export default __webpack_public_path__ + "static/photo12usluge-8d54a1b79c78167ce4d5a1c62898736a.png";